import { Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { CheckInSession } from '@core/entities/checkIn'
import { ICheckInUsersStats } from './ICheckInUsersStats'

export class CheckInUsersStats extends Entity<ICheckInUsersStats> {
  checkedInCount: number
  overdueCheckOutsCount: number
  @Type(() => CheckInSession)
  users: CheckInSession[]

  public getPermitCount(): number {
    return new Set(this.users.map(({ resource }) => resource?.id)).size
  }

  public getSignedInCount(): number {
    return this.checkedInCount - this.overdueCheckOutsCount
  }
}
